module.exports = __webpack_public_path__ + "static/img/story2.9cc41eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/story2.jpg
// module id = Vma6
// module chunks = 0